/**
 * Full Predictor logo — eye icon + "Predictor™" wordmark. Native aspect
 * ratio 141 × 25.6 (≈ 5.5:1); pass matching `h-*` and `w-*` classes.
 *
 * If you re-export the source SVG from Figma, edit it to use
 * `width="100%" height="100%"` and `fill="currentColor"` — we don't
 * normalize at runtime.
 */

import type { JSX } from "preact";
import rawFullLogoSvg from "../assets/images/predictor-full-logo.svg";

export interface PredictorFullLogoProps {
  className?: string;
}

export function PredictorFullLogo({
  className,
}: PredictorFullLogoProps): JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={className}
      // eslint-disable-next-line react/no-danger -- inlined bundled asset, no user input
      dangerouslySetInnerHTML={{ __html: rawFullLogoSvg }}
      style={{ display: "block", lineHeight: 0 }}
    />
  );
}
